/**
 * MIRRORS `freeze-v2/components/tone.js`.
 *
 * COPIED, NOT IMPORTED. disputes-v2 and freeze-v2 are deliberately independent
 * modules: neither may import from the other, so a shared component travels as
 * a copy and any divergence is stated here rather than hidden behind a prop.
 *
 * Divergence from the original: adds `sentenceChipSx`, which the original has
 * no need of because none of its chips carry a sentence or a unit.
 *
 * disputes-v2 already carries three ad-hoc copies of this map (`DisputeGrid.js`,
 * `DisputeDrawer.js`, `EvidenceStudio.js`). This file does not delete them —
 * they are out of scope — but it is the one the freeze drawer's family of files
 * uses, so no fourth copy is written inside `freeze/`.
 *
 * 'ai' has no MUI severity-palette equivalent (it isn't success/warning/error/
 * info), so it maps to PURPLE.
 */
import {INFO, WARNING, SUCCESS, ERROR, MUTED, PURPLE, withOpacity} from '../../../../styles/foundation/colors'
import {FONT, SIZE, WEIGHT} from '../../../../styles/foundation/typography'

/** Every tone name this module's status vocabulary can produce. */
export const TONE_COLOR = {
  ok: SUCCESS,
  warn: WARNING,
  info: INFO,
  neutral: MUTED,
  danger: ERROR,
  ai: PURPLE,
}

/** Resolves a tone name to a colour. Unknown tones fall back to MUTED rather
 * than rendering `undefined` into an sx object. */
export function toneColor(tone) {
  return TONE_COLOR[tone] || MUTED
}

/** MUI `Chip` sx for a tone: tinted background, solid text, module type scale. */
export function chipSx(tone) {
  const color = toneColor(tone)
  return {
    bgcolor: withOpacity(color, 0.12),
    color,
    fontFamily: FONT,
    fontWeight: WEIGHT.semibold,
    fontSize: SIZE['2xs'],
    height: 22,
  }
}

// Rule 13: the app theme title-cases .MuiChip-label on the inner span. A chip
// whose label is a status word survives that; one carrying a sentence or a unit
// does not — 'kg' renders as 'Kg'. Two exports rather than a boolean prop, so a
// call site cannot forget which kind of label it is passing.
export function sentenceChipSx(tone) {
  return {...chipSx(tone), '& .MuiChip-label': {textTransform: 'none'}}
}
